import { type FC, useState } from "react";
import { ToolTip } from "@root/shared/components/ToolTip";
import { Icon } from "@root/shared/components/Icon";
import { getReasonTexts } from "@clientFrontend/features/scout/components/PremiumScoutMessageArea/utils/getReasonTexts";
import {
  type DisplayDisableReason,
  type DisableButtonText,
} from "@clientFrontend/features/scout/components/PremiumScoutMessageArea/type";
import { assignInlineVars } from "@vanilla-extract/dynamic";
import { colors } from "@root/shared/styles/sprinkles.css";
import * as styles from "./styles.css";

type Props = {
  disableText: DisableButtonText;
  displayDisableReason: DisplayDisableReason;
};

export const DisableAiScoutMessageButton: FC<Props> = ({ disableText, displayDisableReason }) => {
  const [isHovered, setIsHovered] = useState(false);

  // 文章量が違い吹き出しの高さが２パターンあるため
  const bottomPosition = displayDisableReason === "userInfoShortage" ? "140px" : "76px";

  return (
    <div className={styles.wrapper}>
      <Icon name="sparkle" fontSize="16px" />
      <p className={styles.buttonText}>{disableText}</p>
      {disableText === "AIでメッセージを作成できません" && (
        <div
          className={styles.toolTipTrigger}
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
        >
          {displayDisableReason && <Icon name="tooltip" color={colors.TextLink} fontSize="16px" />}

          {/* ツールチップ本体 */}
          {displayDisableReason && isHovered && (
            <div
              className={styles.reasonWrapper}
              style={assignInlineVars({ [styles.bottomPosition]: bottomPosition })}
            >
              <ToolTip arrowPosition="bottomRight" isHovered={isHovered} className={styles.toolTip}>
                <>
                  <b>{getReasonTexts(displayDisableReason).boldText}</b>
                  <p>{getReasonTexts(displayDisableReason).text}</p>
                </>
              </ToolTip>
            </div>
          )}
        </div>
      )}
    </div>
  );
};
